import FacebookIcon from '@mui/icons-material/Facebook';
import LanguageIcon from '@mui/icons-material/Language';
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import type { OrgSocialPlatform } from '@re/shared';

function InstagramIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4c0 3.2-2.6 5.8-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8C2 4.6 4.6 2 7.8 2zm0 2A3.8 3.8 0 0 0 4 7.8v8.4A3.8 3.8 0 0 0 7.8 20h8.4a3.8 3.8 0 0 0 3.8-3.8V7.8A3.8 3.8 0 0 0 16.2 4H7.8zm9.4 2.2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
    </SvgIcon>
  );
}

function XTwitterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
    </SvgIcon>
  );
}

function TikTokIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M16.6 5.82c.81.74 1.78 1.22 2.83 1.34V9.5c-.97-.03-1.92-.35-2.73-.92v6.83c0 2.45-1.99 4.44-4.44 4.44-2.45 0-4.44-1.99-4.44-4.44s1.99-4.44 4.44-4.44c.23 0 .45.02.67.06v2.82a1.74 1.74 0 0 0-.67-.13c-.97 0-1.76.79-1.76 1.76s.79 1.76 1.76 1.76 1.76-.79 1.76-1.76V2h2.54c.12 1.08.58 2.07 1.24 2.82z" />
    </SvgIcon>
  );
}

export function OrgSocialPlatformIcon({ platform, ...props }: SvgIconProps & { platform: OrgSocialPlatform }) {
  switch (platform) {
    case 'website':
      return <LanguageIcon {...props} />;
    case 'instagram':
      return <InstagramIcon {...props} />;
    case 'facebook':
      return <FacebookIcon {...props} />;
    case 'twitter':
      return <XTwitterIcon {...props} />;
    case 'tiktok':
      return <TikTokIcon {...props} />;
    default:
      return <LanguageIcon {...props} />;
  }
}
